/**
 * Extract the `filename` from a `Content-Disposition` header value.
 * Supports both `filename="..."` and the RFC 5987 `filename*=UTF-8''...` form.
 * Returns null when no filename can be parsed.
 */
export function parseContentDispositionFilename(
  disposition: string | undefined,
): string | null {
  if (!disposition) {
    return null;
  }
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      // Fall through to the plain `filename=` form.
    }
  }
  const plainMatch = /filename="?([^";]+)"?/i.exec(disposition);
  return plainMatch?.[1] ?? null;
}
